const segmentBasic = {
  getlist: 'segmentbase/getlist',
  update: 'segmentbase/update',
  getall: 'segmentbase/getall',
  getTypes: 'segmentbase/getsegmenttype',
  add: 'segmentbase/add',
  changeTitle: 'segmentbase/change-title'
}
export default segmentBasic
